import { IAirdropTaskRender } from "./task-renderer.types";
import { QuestTaskButton } from "../quest-task-button";

export const RetweetRenderer = ({
  task,
  completeTaskMutation,
  campaign,
}: IAirdropTaskRender) => {
  if (!campaign) return null;

  const taskFromCampaign = campaign?.tasks?.find((t) => t.id === task.taskGuid);
  if (!taskFromCampaign) return null;

  return (
    <div className="flex items-center gap-2">
      <QuestTaskButton
        buttonText="Claim"
        taskMutation={completeTaskMutation}
        task={task}
        onClick={async () => {
          await completeTaskMutation.mutateAsync({
            campaignId: campaign.id,
            taskName: task.taskName,
            taskGuid: task.taskGuid,
            groupId: campaign.campaignGroup,
          });
          return;
        }}
      />
    </div>
  );
};
